/**
 * L'adresse à donner à l'image d'un produit Merchant Center.
 *
 * ⚠️ `imageLink` / `imageUrl` est l'image **du marchand**, servie par son propre serveur et dans
 * sa taille d'origine : relevé sur le compte 624-538-0268, **344 ko en moyenne et jusqu'à 1 Mo**
 * pour une case de 60 px. La première page de l'étiquetage manuel — vingt lignes — pesait
 * **9,74 Mo**, et un seul fichier a mis **8 secondes** à venir.
 *
 * `vignetteUrl` / `thumbnailLink` est la copie recompressée par Google (`thumbnail_link` de
 * `product_view`, collectée par `merchantApi.collecterVignettes`) : **1,79 Mo** pour la même
 * page, soit **cinq fois moins d'octets**, et servie par `encrypted-tbn*.gstatic.com` — un seul
 * hôte en HTTP/2 au lieu d'autant de serveurs marchands que le catalogue en référence. C'est de
 * là que venaient les traînardes.
 *
 * ⚠️ **On la préfère, on ne l'exige pas.** Elle manque pour les produits que Google n'a pas
 * encore recopiés, et s'en remettre à elle seule afficherait « Pas d'image » là où le marchand
 * en a une. La condition d'affichage reste donc posée sur l'image du marchand, et c'est
 * seulement la source qui passe par ici.
 *
 * ⚠️ **Elle ne dispense pas de `loading="lazy"`** : malgré son nom, elle fait 1500 × 1500 comme
 * l'original — vérifié dans l'en-tête JPEG, et aucun paramètre de redimensionnement n'est
 * honoré. Le gain est sur les octets transférés, pas sur le décodage. Les deux vont ensemble.
 *
 * Les trois noms coexistent parce que les trois routes qui servent ces produits nomment le
 * champ différemment : `imageUrl` pour l'étiquetage Shopping, `imageLink` pour le dashboard
 * « Performances par produit », `image_url` pour `get_data`. Les unifier demanderait de reprendre
 * les écrans qui les lisent ; les accepter tous les trois coûte une ligne.
 */
export const adresseDeVignette = (produit) =>
  produit?.vignetteUrl
  || produit?.thumbnailLink
  || produit?.imageUrl
  || produit?.imageLink
  || produit?.image_url
  || '';

export default adresseDeVignette;
